/* Alinga | 07-10-2026
   PDP: when a product has no reviews, hide the Reviews.io "(0 Reviews)" count so only the
   empty stars show. Products with 1+ reviews are untouched.
   Scoped to .pdp_custom_review_wrapper (the review row under the product title). */
(function () {
  'use strict';

  var WRAPPER = '.pdp_custom_review_wrapper';
  var COUNT = '.ruk-rating-snippet-count';

  function hasZeroReviews(el) {
    var match = (el.textContent || '').match(/(\d[\d,.]*)\s*reviews?/i);
    return !!match && parseInt(match[1].replace(/[^\d]/g, ''), 10) === 0;
  }

  function update() {
    document.querySelectorAll(WRAPPER + ' ' + COUNT).forEach(function (el) {
      if (hasZeroReviews(el)) {
        el.style.setProperty('display', 'none', 'important');
      } else if (el.style.getPropertyValue('display') === 'none') {
        el.style.removeProperty('display');
      }
    });
  }

  function init() {
    var wrappers = document.querySelectorAll(WRAPPER);
    if (!wrappers.length) return;

    update();

    // Reviews.io renders (and re-renders) the snippet asynchronously, so react to changes.
    wrappers.forEach(function (wrapper) {
      new MutationObserver(update).observe(wrapper, {
        childList: true,
        subtree: true,
        characterData: true,
      });
    });

    // Fallback for slow widget loads.
    window.addEventListener('load', update);
    setTimeout(update, 1000);
    setTimeout(update, 3000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
